import { StyledSearch } from './SearchInput.styles';
import { SearchProps } from './SearchInput.interface';

export const SearchInput = (props: SearchProps) => {
  return <StyledSearch {...props} />;
};
